import React, { useState } from 'react';
import { Button } from '../components/Button';
import { Modal } from '../components/Modal';
import { Home, ShieldCheck, TrendingUp, FileText, CheckCircle2, Gift, Users, AlertTriangle, DollarSign, Clock } from 'lucide-react';
export function SalesPage() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="font-inter text-navy bg-offwhite min-h-screen" data-id="element-13">
      {/* 1. HERO SECTION */}
      <section className="bg-navy text-white pt-20 pb-24 px-6 relative overflow-hidden" data-id="element-14">
        <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center mix-blend-overlay" data-id="element-15"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-16">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-17">
            <div className="flex-1 text-center lg:text-left" data-id="element-18">
              <div className="inline-block bg-gold/20 text-gold font-semibold px-4 py-1.5 rounded-full mb-6 text-sm tracking-wide uppercase" data-id="element-19">
                Sistema Probado para Familias Latinas
              </div>
              <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-gold leading-tight mb-6" data-id="element-20">
                DE INQUILINO A PROPIETARIO: El Sistema Blindado para Comprar tu
                Casa en USA
                <span className="block text-3xl md:text-4xl text-white mt-2 opacity-90" data-id="element-21">
                  (Sin Errores y Sin Miedo)
                </span>
              </h1>
              <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-22">
                El mapa exacto paso a paso para navegar el sistema bancario,
                dominar el proceso de cierre y recibir las llaves de tu hogar en
                90 días o menos... incluso si crees que el sistema está en tu
                contra.
              </p>
              <Button onClick={scrollToOffer} className="w-full sm:w-auto" data-id="element-23">
                ¡SÍ, QUIERO MI CASA AHORA!
              </Button>
            </div>
            <div className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-24">
              <div className="relative" data-id="element-25">
                <div className="absolute -inset-4 bg-gold/20 rounded-2xl blur-xl" data-id="element-26"></div>
                <img src="https://cdn.magicpatterns.com/uploads/nya9rQpUcytd8aB6UbVXaK/image.png" alt="El Código del Propietario Digital Bundle" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-27" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. EMOTIONAL HOOK */}
      <section className="py-20 px-6 bg-offwhite" data-id="element-28">
        <div className="max-w-3xl mx-auto" data-id="element-29">
          <p className="text-xl md:text-2xl font-medium italic text-navy/80 leading-relaxed mb-12 text-center" data-id="element-30">
            "Son las 11:00 PM. Estás en Zillow otra vez... Mirando esa casa que
            sería perfecta para tu familia. Te imaginas a tus hijos jugando en
            ese patio, pero en lugar de emoción, sientes un nudo en el
            estómago."
          </p>

          <div className="space-y-6 mb-12" data-id="element-31">
            <p className="text-center font-semibold text-lg text-navy" data-id="element-32">
              Te preguntas:
            </p>

            <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-gold transform transition-transform hover:-translate-y-1" data-id="element-33">
              <p className="text-lg font-medium text-navy" data-id="element-34">
                "¿Y si el banco me rechaza por mi crédito?"
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-gold transform transition-transform hover:-translate-y-1" data-id="element-35">
              <p className="text-lg font-medium text-navy" data-id="element-36">
                "¿Y si me falta dinero al final del camino?"
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-gold transform transition-transform hover:-translate-y-1" data-id="element-37">
              <p className="text-lg font-medium text-navy" data-id="element-38">
                "¿Y si me engañan con la letra pequeña y pierdo mis ahorros?"
              </p>
            </div>
          </div>

          <div className="bg-navy text-white p-8 rounded-2xl text-center shadow-xl" data-id="element-39">
            <p className="text-lg md:text-xl leading-relaxed" data-id="element-40">
              Esa sensación de estar tirando tu dinero en una renta que sube
              cada año mientras construyes la riqueza de otro,{' '}
              <span className="text-gold font-bold" data-id="element-41">termina hoy</span>. No te
              falta capacidad, te falta el código de acceso al sistema
              hipotecario de este país.
            </p>
          </div>
        </div>
      </section>

      {/* 3. THE PROBLEM */}
      <section className="py-20 px-6 bg-navy text-white" data-id="element-42">
        <div className="max-w-4xl mx-auto text-center" data-id="element-43">
          <AlertTriangle className="w-16 h-16 text-gold mx-auto mb-6" data-id="element-44" />
          <h2 className="font-playfair text-4xl md:text-5xl text-gold mb-8" data-id="element-45">
            El Problema Real
          </h2>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-46">
            Comprar una casa en Estados Unidos no es solo cuestión de dinero o
            de tener el crédito arreglado.{' '}
            <span className="text-white font-bold" data-id="element-47">
              Es un juego de reglas invisibles.
            </span>
          </p>
          <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mx-auto" data-id="element-48">
            Para los bancos, si no sabes presentar tus documentos, eres un
            "riesgo". El problema real no es solo el score; es el miedo a los
            gastos de cierre ocultos, a los términos en inglés que nadie te
            explica y a la frustración de ver cómo otros ya tienen su casa
            simplemente porque sabían cómo "hablar el idioma" del banco.
          </p>
        </div>
      </section>

      {/* 4. WHY WHAT YOU TRIED DIDN'T WORK */}
      <section className="py-20 px-6 bg-offwhite" data-id="element-49">
        <div className="max-w-5xl mx-auto" data-id="element-50">
          <h2 className="font-playfair text-3xl md:text-4xl text-navy text-center mb-16" data-id="element-51">
            ¿Por qué sigues rentando a pesar de trabajar tanto?
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-52">
            <div className="bg-white p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-53">
              <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-6" data-id="element-54">
                <Users className="w-6 h-6" data-id="element-55" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-56">
                Confiaste en consejos de "amigos"
              </h3>
              <p className="text-gray-600" data-id="element-57">
                Que compraron hace 10 años cuando las reglas eran totalmente
                distintas.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-58">
              <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-6" data-id="element-59">
                <TrendingUp className="w-6 h-6" data-id="element-60" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-61">
                Esperaste a que el mercado bajara
              </h3>
              <p className="text-gray-600" data-id="element-62">
                Mientras la inflación y las rentas se comían tus ahorros mes
                tras mes.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md border border-gray-100" data-id="element-63">
              <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-6" data-id="element-64">
                <DollarSign className="w-6 h-6" data-id="element-65" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-66">
                Creíste que necesitabas el 20%
              </h3>
              <p className="text-gray-600" data-id="element-67">
                Ignorando que existen programas que te permiten comprar con el
                3.5% o incluso con el 0% si sabes dónde buscar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. THE UNIQUE MECHANISM */}
      <section className="py-20 px-6 bg-navy text-white" data-id="element-68">
        <div className="max-w-4xl mx-auto text-center" data-id="element-69">
          <ShieldCheck className="w-20 h-20 text-gold mx-auto mb-8" data-id="element-70" />
          <h2 className="font-playfair text-4xl md:text-5xl text-gold mb-8" data-id="element-71">
            Presentamos "EL CÓDIGO DEL PROPIETARIO"
          </h2>
          <p className="text-xl md:text-2xl font-medium mb-8" data-id="element-72">
            Este no es un libro de motivación. Es un{' '}
            <span className="text-gold" data-id="element-73">
              Manual Operativo de Ingeniería Financiera
            </span>{' '}
            diseñado para familias latinas.
          </p>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-74">
            Es el sistema que te enseña a armar tu "Equipo de Poder", a blindar
            tu préstamo para que el banco no pueda decirte que no, y a manejar
            el estrés emocional del proceso para que llegues a la firma con
            total seguridad.
          </p>
        </div>
      </section>

      {/* 6. WHAT YOU GET */}
      <section className="py-20 px-6 bg-offwhite" data-id="element-75">
        <div className="max-w-4xl mx-auto" data-id="element-76">
          <h2 className="font-playfair text-3xl md:text-4xl text-navy text-center mb-12" data-id="element-77">
            Al adquirir El Código del Propietario, tendrás acceso inmediato a:
          </h2>

          <div className="space-y-6" data-id="element-78">
            {[{
            title: 'La Estrategia del Crédito Invisible',
            desc: 'Cómo hacer que el banco ame tu perfil (más allá del score).'
          }, {
            title: 'El Mapa del Proceso (1x1)',
            desc: 'Desde la preaprobación hasta el día de la firma.'
          }, {
            title: 'Guía de Préstamos',
            desc: 'Cuál te conviene más (FHA, Convencional o ITIN).'
          }, {
            title: 'Manual de Negociación',
            desc: 'Cómo lograr que el vendedor pague tus costos de cierre.'
          }, {
            title: 'Protección Post-Cierre',
            desc: 'Qué hacer en tus primeros 100 días para proteger tu inversión.'
          }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-79">
                <CheckCircle2 className="w-8 h-8 text-green-500 flex-shrink-0 mt-1" data-id="element-80" />
                <div data-id="element-81">
                  <h3 className="text-xl font-bold text-navy mb-2" data-id="element-82">
                    {item.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-83">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. BONUSES */}
      <section className="py-20 px-6 bg-navy text-white" data-id="element-84">
        <div className="max-w-5xl mx-auto" data-id="element-85">
          <div className="text-center mb-16" data-id="element-86">
            <Gift className="w-16 h-16 text-gold mx-auto mb-6" data-id="element-87" />
            <h2 className="font-playfair text-4xl md:text-5xl text-gold mb-6" data-id="element-88">
              Bonos Exclusivos
            </h2>
            <p className="text-xl text-gray-300" data-id="element-89">
              Si ordenas HOY, te llevas estos 4 Bonos de Regalo:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-90">
            {[{
            title: 'Checklist Maestro de Visita',
            desc: "No compres una 'casa limón'."
          }, {
            title: 'El Interrogatorio del Realtor',
            desc: 'Preguntas clave para que no te engañen.'
          }, {
            title: 'Guía de Gastos de Cierre',
            desc: 'Calcula cada centavo y evita sorpresas.'
          }, {
            title: 'Plan de 180 Días',
            desc: 'La ruta si planeas comprar en los próximos 6 meses.'
          }].map((bono, index) => <div key={index} className="bg-navy-light p-8 rounded-2xl border border-gold/30 relative overflow-hidden group hover:border-gold transition-colors" data-id="element-91">
                <div className="absolute top-0 right-0 bg-gold text-navy font-bold px-4 py-1 rounded-bl-lg" data-id="element-92">
                  BONO {index + 1}
                </div>
                <h3 className="text-xl font-bold text-gold mb-3 mt-4" data-id="element-93">
                  {bono.title}
                </h3>
                <p className="text-gray-300" data-id="element-94">{bono.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. WHO IS THIS FOR & PROOF */}
      <section className="py-20 px-6 bg-offwhite" data-id="element-95">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center" data-id="element-96">
          <div data-id="element-97">
            <h2 className="font-playfair text-3xl md:text-4xl text-navy mb-8" data-id="element-98">
              ¿Para quién es esto?
            </h2>
            <ul className="space-y-6" data-id="element-99">
              <li className="flex items-center gap-4" data-id="element-100">
                <Home className="w-6 h-6 text-gold flex-shrink-0" data-id="element-101" />
                <span className="text-lg text-gray-700" data-id="element-102">
                  Familias en USA cansadas de mudanzas y subidas de renta.
                </span>
              </li>
              <li className="flex items-center gap-4" data-id="element-103">
                <FileText className="w-6 h-6 text-gold flex-shrink-0" data-id="element-104" />
                <span className="text-lg text-gray-700" data-id="element-105">
                  Compradores primerizos que se sienten intimidados por el
                  papeleo.
                </span>
              </li>
              <li className="flex items-center gap-4" data-id="element-106">
                <ShieldCheck className="w-6 h-6 text-gold flex-shrink-0" data-id="element-107" />
                <span className="text-lg text-gray-700" data-id="element-108">
                  Personas con Social o ITIN que quieren construir un patrimonio
                  real.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border-t-4 border-gold" data-id="element-109">
            <AlertTriangle className="w-12 h-12 text-red-500 mb-6" data-id="element-110" />
            <p className="text-xl text-navy font-medium leading-relaxed mb-6" data-id="element-111">
              Un error en la inspección o una mala elección de préstamo puede
              costarte entre{' '}
              <span className="font-bold text-red-600" data-id="element-112">
                $10,000 y $30,000 dólares
              </span>
              .
            </p>
            <p className="text-gray-600" data-id="element-113">
              Este manual te entrega el conocimiento que los bancos cobran miles
              por gestionar, por una fracción de ese costo.
            </p>
          </div>
        </div>
      </section>

      {/* 9. OFFER + PRICE BLOCK */}
      <section id="offer-section" className="py-24 px-6 bg-navy text-white relative" data-id="element-114">
        <div className="max-w-5xl mx-auto" data-id="element-115">
          <div className="bg-navy-light rounded-3xl p-8 md:p-12 border-2 border-gold shadow-2xl relative overflow-hidden" data-id="element-116">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 bg-gold text-navy font-bold px-8 py-2 rounded-b-xl text-lg uppercase tracking-wider" data-id="element-117">
              Oferta de Lanzamiento
            </div>

            <div className="grid md:grid-cols-2 gap-12 items-center mt-8" data-id="element-118">
              <div data-id="element-119">
                <img src="https://cdn.magicpatterns.com/uploads/r8qbuxRtfvgoqcDP3XauVW/image.png" alt="El Código del Propietario Bundle" className="w-full h-auto rounded-xl shadow-lg" data-id="element-120" />
              </div>

              <div className="text-center md:text-left" data-id="element-121">
                <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-122">
                  Todo el Sistema "El Código del Propietario" <br data-id="element-123" />
                  <span className="text-gold" data-id="element-124">+ Los 4 Bonos de Regalo</span>
                </h3>

                <div className="mb-8" data-id="element-125">
                  <p className="text-gray-400 text-lg mb-2" data-id="element-126">Precio regular:</p>
                  <div className="text-2xl md:text-3xl font-inter text-gray-500 line-through mb-2" data-id="element-127">
                    $27.00 USD
                  </div>
                  <p className="text-gold font-semibold text-lg mb-1 uppercase tracking-wide" data-id="element-128">
                    🔥 Oferta especial — Por solo:
                  </p>
                  <div className="text-6xl md:text-7xl font-playfair font-bold text-gold mb-4" data-id="element-129">
                    $6.39{' '}
                    <span className="text-2xl text-gray-300 font-inter" data-id="element-130">
                      USD
                    </span>
                  </div>
                  <div className="inline-block bg-green-500/20 text-green-400 font-bold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-131">
                    Ahorras más del 76%
                  </div>
                  <p className="text-gray-300 flex items-center justify-center md:justify-start gap-2" data-id="element-132">
                    <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-133" /> Un solo
                    pago. Sin suscripciones. Acceso de por vida.
                  </p>
                </div>

                <div id="download-section" className="space-y-4" data-id="element-134">
                  <Button className="w-full text-xl py-5" data-id="element-135">
                    ¡Sí, Quiero Mi Libro Ahora por $6.39!
                  </Button>
                  <p className="text-center text-sm text-gray-400" data-id="element-136">
                    Haz clic arriba para descargar el sistema y recibir tus
                    llaves pronto.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-navy-dark text-gray-400 py-8 text-center px-6" data-id="element-137">
        <div className="flex items-center justify-center gap-6 mb-4" data-id="element-138">
          <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-gold transition-colors text-sm underline underline-offset-2" data-id="element-139">
            Política de Privacidad
          </button>
          <span className="text-gray-600" data-id="element-140">|</span>
          <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-gold transition-colors text-sm underline underline-offset-2" data-id="element-141">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-sm" data-id="element-142">
          © {new Date().getFullYear()} El Código del Propietario. Todos los
          derechos reservados.
        </p>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-143">
        <p className="font-semibold text-base" data-id="element-144">
          Última actualización: Abril 2026
        </p>
        <p data-id="element-145">
          En El Código del Propietario, respetamos tu privacidad y nos
          comprometemos a proteger tu información personal. Esta política
          describe cómo recopilamos, usamos y protegemos tus datos.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-146">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-147">
          Recopilamos información que nos proporcionas directamente al realizar
          una compra, como tu nombre, dirección de correo electrónico e
          información de pago. No almacenamos datos de tarjetas de crédito en
          nuestros servidores.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-148">2. Uso de la Información</h3>
        <p data-id="element-149">
          Utilizamos tu información para procesar tu compra, enviarte el
          producto digital adquirido y comunicarnos contigo sobre
          actualizaciones relacionadas con tu compra.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-150">3. Protección de Datos</h3>
        <p data-id="element-151">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-152">4. Terceros</h3>
        <p data-id="element-153">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Esto no incluye proveedores de servicios de confianza que
          nos ayudan a operar nuestro sitio web y procesar pagos.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-154">5. Cookies</h3>
        <p data-id="element-155">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-156">6. Tus Derechos</h3>
        <p data-id="element-157">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento. Puedes ejercer estos derechos contactándonos
          directamente.
        </p>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-158">
        <p className="font-semibold text-base" data-id="element-159">
          Última actualización: Abril 2026
        </p>
        <p data-id="element-160">
          Al adquirir El Código del Propietario, aceptas los siguientes términos
          y condiciones. Por favor, léelos cuidadosamente antes de realizar tu
          compra.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-161">1. Producto Digital</h3>
        <p data-id="element-162">
          El Código del Propietario es un producto digital informativo. Al
          completar tu compra, recibirás acceso inmediato al contenido digital.
          Este producto es para uso personal y educativo únicamente.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-163">2. Propiedad Intelectual</h3>
        <p data-id="element-164">
          Todo el contenido del producto está protegido por derechos de autor.
          Queda prohibida la reproducción, distribución o reventa del material
          sin autorización expresa por escrito.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-165">
          3. Descargo de Responsabilidad
        </h3>
        <p data-id="element-166">
          La información proporcionada en este producto es de carácter educativo
          y no constituye asesoría financiera, legal o hipotecaria profesional.
          Los resultados pueden variar según las circunstancias individuales de
          cada persona.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-167">4. Política de Reembolso</h3>
        <p data-id="element-168">
          Debido a la naturaleza digital del producto y el acceso inmediato al
          contenido, todas las ventas son finales. No se ofrecen reembolsos una
          vez completada la descarga.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-169">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-170">
          El Código del Propietario no se hace responsable de decisiones
          financieras tomadas basándose en el contenido del producto.
          Recomendamos siempre consultar con profesionales certificados antes de
          tomar decisiones de compra de vivienda.
        </p>
        <h3 className="font-bold text-base mt-4" data-id="element-171">6. Modificaciones</h3>
        <p data-id="element-172">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas inmediatamente después de
          su publicación.
        </p>
      </Modal>
    </div>;
}